import React, { useEffect, useState } from "react";
import Recipe from "./Recipe";
import "./App.css";

const App = () => {
  const APP_ID = "823ce4e1";
  const APP_KEY = "919ef3d5f98926115b0f932c3e3b4331";

  const [recipes, setRecipes] = useState([]);

  const [search, setSearch] = useState("apple");

  const [query, setQuery] = useState("apple");

  const [searchStart, setSearchStart] = useState(0);

  let chunk = 10;

  let page = (searchStart / chunk) + 1;

  let pageError = '';
  

  useEffect(() => {
    getRecipes();
  }, [query, searchStart]);

  const getRecipes = async () => {
    const response = await fetch(
      `https://api.edamam.com/search?q=${query}&app_id=${APP_ID}&app_key=${APP_KEY}&from=${searchStart}&to=${searchStart + chunk}`
    );
    const data = await response.json();
    setRecipes(data.hits);
  };

  const updateSearch = (e) => {
    setSearch(e.target.value);
  };
  const getSearch = (e) => {
    e.preventDefault();
    setSearchStart(0);
    setQuery(search);
  };
  const nextPage = () => {
    setSearchStart(searchStart + chunk);
    window.scrollTo(0, 0);
  }
  const prevPage = () => {
    if (searchStart != 0) {
      setSearchStart(searchStart - chunk)
      window.scrollTo(0, 0);
    } else {
      pageError = 'You are already on the first page!';
    }
  }


  return (
    <div className="App">
      <form onSubmit={getSearch} className="search-form">
        <input
          type="text"
          className="search-bar"
          value={search}
          onChange={updateSearch}
        />
        <button type="submit" className="search-button">
          Search
        </button>
      </form>
      {      recipes.map(recipe => (
        
        <Recipe
          key={`${recipe.recipe.label}${recipe.recipe.calories}`}

          title={recipe.recipe.label}
          calories={Math.ceil(recipe.recipe.calories)}
          image={recipe.recipe.image}
          url={recipe.recipe.url}
          portions={recipe.recipe.yield}
          ingredients={recipe.recipe.ingredients} 

        />
      ))}
      <div className="nav-buttons">
        <button className='button-more' onClick={prevPage}>Previous page</button>
        <button className='button-more' onClick={nextPage}>Next page</button>
      </div>
      <p className='page'>Page: {page}</p>
      <p className='page-error'>{pageError}</p>
    </div>
  );
};

export default App;
